import React from 'react';
import { CtaButton } from './CtaButton';
import { FrameworkFlow } from './FrameworkFlow';
import { IMAGES } from '../data/coachSystem';
export function Hero() {
  return <header className="border-b border-navy-line bg-ivory" data-id="element-47" data-mp="9ktchjcqjuvn">
      <div className="mx-auto w-full max-w-[42rem] px-4 pb-9 pt-7 text-center sm:px-6 sm:pb-12 sm:pt-10 lg:max-w-3xl lg:pb-16 lg:pt-14" data-id="element-48" data-mp="9lbgx39jxfen">
        <p className="eyebrow text-[0.66rem] font-semibold text-teal sm:text-[0.72rem]" data-id="element-49" data-mp="129h2ttccdag2">
          Girls Flag Football Coach System™
        </p>

        <h1 className="mt-4 font-display text-[2.05rem] font-medium leading-[1.1] tracking-tight text-navy sm:text-[2.75rem] lg:text-[3.15rem]" data-id="element-50" data-mp="xbfht2vcv11y">
          The Complete Coaching System for Girls Flag Football Coaches
        </h1>

        <p className="mx-auto mt-3.5 max-w-[36rem] text-[0.98rem] leading-relaxed text-navy-muted sm:text-[1.05rem]" data-id="element-51" data-mp="nbydaoruat7k">
          Save hours of planning, run better practices, and coach with
          confidence — without building every practice from scratch.
        </p>

        <img src={IMAGES.bundle} alt="The complete Girls Flag Football Coach System™ bundle: six written coaching volumes shown as book covers beside the system box." className="mx-auto -mb-1 mt-4 w-full max-w-[27rem] sm:mt-6 sm:max-w-[30rem] lg:max-w-[33rem]" width={1520} height={1030} data-id="element-52" data-mp="3j9u1d0dmvqmc" />

        <p className="mt-4 text-[0.7rem] font-bold uppercase tracking-[0.18em] text-navy" data-id="element-53" data-mp="30i18r72h87f5">
          Girls Flag Football Coach System™
        </p>

        <p className="mt-2 text-[0.98rem] font-semibold leading-snug text-navy sm:text-[1.05rem]" data-id="element-54" data-mp="359j9pv4i2804">
          6 Professional Coaching Volumes{' '}
          <span className="text-teal" aria-hidden="true" data-id="element-55" data-mp="2qi0o9hsvfl9d">
            +
          </span>{' '}
          5 Practical Bonuses
        </p>

        <FrameworkFlow className="mt-3.5" data-id="element-56" data-mp="2hix2g62bkrr6" />

        <CtaButton label="Get instant access" size="lg" className="mt-6" data-id="element-57" data-mp="2hl9td8q22cgd" />
        <p className="mt-2.5 text-[0.8rem] text-navy-muted" data-id="element-58" data-mp="2ljh0dbupvzed">
          Instant digital access • One-time payment
        </p>
      </div>
    </header>;
}